<template>
  <div>
    <!-- toasts message -->
       <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->
 <!-- Confirmation delete box -->
        <v-layout row justify-center>
            <v-dialog v-model="confirmModel" max-width="290">
                <v-card>
                    <v-card-text>Are you sure you want to delete this data?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
                        <v-btn color="green darken-1" flat="flat" @click.native="confirmDelete(row_index, delete_id)">
                            Agree
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <!-- /Confirmation delete box -->
    <v-progress-circular
      v-if="Loader"
      :size="70"
      :width="7"
      color="teal"
      indeterminate
    ></v-progress-circular>

    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>
            <v-flex xs12 sm4 md5>
              <v-text-field
                label="Document Name"
                v-model="formSchema.document_title"
                :rules="[(v) => !!v || 'Field is required']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm4 md1> </v-flex>

            <v-flex xs12 sm6 md4>
              <label for="">Select Document</label>
              <input type="file" id="doc" @change="getImage" />
            </v-flex>
            <v-flex xs12 sm6 md4>
              <!-- <div class="image-preview" v-if="formSchema.document.length > 0">
                <img class="preview" :src="doc_preview" />
              </div> -->
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="previous">
        <v-icon>arrow_back_ios</v-icon>Previous
      </v-btn>
      <v-btn color="primary" @click="submitDocument">
        {{btnTitle}}
        <v-icon>save</v-icon>
      </v-btn>
      <v-btn color="secondary" @click="reset">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn color="blue darken-1" flat @click.native="home">Home</v-btn>
    </v-card-actions>

    <v-card>
      <v-card-title>
        <span class="headline">Upload Document List</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="items" :search="search">
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ ++props.index }}</td>
          <td class="text-xs-left">{{ props.item.document_title }}</td>
          <td class="text-xs-left">
            <a
              :href="`${public_path}${props.item.document}`"
              target="_blank"
              rel="noopener noreferrer"
              download=""
            >
              <v-icon v style="vertical-align:top; font-size:30px;"
                >cloud_download</v-icon
              >
            </a>
          </td>

          <td class="justify-center layout px-0">
            <v-btn
              icon
              class="mx-0"
              
              @click="editItem(props.item)"
            >
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <v-btn
              icon
              class="mx-0"
          
              @click="deleteItem(props.index, props.item.id)"
            >
              <v-icon color="pink">delete</v-icon>
            </v-btn>
          </td>
        </template>

         <template slot="no-data" class="error">
          <div align="center">No Data Found</div>
        </template>
      </v-data-table>
      <!-- <v-data-table item-key="name" class="elevation-1" loading loading-text="Loading... Please wait"></!-->
    </v-card>
  </div>
</template>

<script>
const commonService = require("../../../../services/common.service");
import ServerPath from "../../../../server-path/server-path";

export default {
  data: () => ({
    valid: true,
    e1: 0,
    show: false,
    Loader: false,
    //operation_act_id: 1,
  SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",
    formSchema: {
      id: "",
      package_id: sessionStorage.getItem("package_info"),
      document_title: "",
      document: "",
    },
    doc_preview: require("../../../../assets/logo.png"),
    search: "",
    headers: [
      {
        text: "Sl#",
        align: "left",
        sortable: false,
        value: "id",
      },
      {
        text: "Document Name",

        sortable: false,
        value: "document_title",
      },
      {
        text: "File",

        sortable: false,
        value: "",
      },
      { text: "Actions", value: "", align: "center" },
    ],
    items: [],
    publicPath: "",
    row_index: "",
    delete_id:"",
    confirmModel:false,
  }),

  created() {
    this.loadData();
    this.public_path = ServerPath.serverPath + "/assets/uploads/";
  },
  computed: {
    userRole() {
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;
      return role;
    },
    btnTitle(){
       return this.formSchema.id > 0 ? 'Update' : 'Save'
    },
    formTitle(){
       return this.formSchema.id > 0 ? 'Update Document' : 'Add Document'
    }
  },
  methods: {
    getImage(e) {
      let fileInput = e.target;
      if (fileInput.files && fileInput.files[0]) {
        let file = new FileReader();
        file.onload = (e) => {
          this.formSchema.document = e.target.result;
        };
        file.readAsDataURL(fileInput.files[0]);
      }
    },
    loadData() {
      let formSchema = this.formSchema;
      commonService
        .getAllDataById(this.operation_act_id, "proc_document")
        .then((res) => {
          if (res.data) {
            this.formSchema = res.data;
            console.log("this.formSchema = ", this.formSchema);
          }
          this.show = true;
        });
    },
    getAllDocuments() {
      commonService.getAllData("proc_document").then((res) => {
        this.items = res.data;
        // console.log(this.subMenuList)
      });
    },

    home() {
      this.$router.push("/procurement/package_revision");
    },

    submitDocument() {
      let root = this;
      // this.Loader = true;
      let formSchema = this.formSchema;
      if (root.$refs.form.validate()) {

					if ( formSchema.id > 0 )
					{                     
						commonService.updateFormData(this.formSchema, 'proc_document').then(res => {
					
							if(res.status == 1){
                 this.SnackbarVal.color = "success";
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
                  // this.formSchema.document = 0
                  this.formSchema.id = 0
                document.getElementById('doc').value= null;
          this.getAllDocuments()

                 this.$refs.form.reset();

							}
						});
					}
					else
					{
						commonService.insertFormData(this.formSchema, 'proc_document').then(res => {						
							if(res.status == 1){
							    this.SnackbarVal.color = "success";
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
                document.getElementById('doc').value= null;
                  // this.formSchema.document = 0
                  this.$refs.form.reset();
          this.getAllDocuments()

              
							}
						});
          }
				}
    },
    editItem(item) {
      this.formSchema = item;
      this.showForm = true;
      window.scrollTo({
        // scroling to top
        top: 0,
        left: 100,
        behavior: "smooth",
      });
    },
    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "proc_document").then((res) => {
         if (res.status == 1) {
          this.items.splice(row_index, 1);
          this.getAllDocuments();
          this.SnackbarVal.color = "success";

        } else {
          this.SnackbarVal.color = "error";
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        this.confirmModel = false;
        this.dialog2 = false;
        // this.reloadData()
      });
    },
    nextStep() {
      this.Loader = false;
      this.$emit("emitForm3", 3);
    },

    previous() {
      this.$emit("emitForm3", 2);
    },

    close: function() {
      this.$refs.form.reset();
    },
    reset(){
      if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
      }
    }
  },
  mounted() {
    this.getAllDocuments();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/procurement/package_revision/step_forms/Document.vue